module.exports = __webpack_public_path__ + "media/images/icon__close--rb-white@3x-a01b00ba7a63483558adcb28d0b86cd0.png";